import "./force-unlock-modal.css";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const ForceUnlockModal = ({
	onClose,
	isOpen,
	forceUnlock,
}: {
	onClose: () => void;
	isOpen: boolean;
	forceUnlock: () => void;
}) => {
	const handleConfirm = () => {
		forceUnlock();
		onClose();
	};

	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"force-unlock-modal"}
			confirmText={"Force unlock shipment"}
			onCancel={onClose}
			onClose={onClose}
			onConfirm={() => handleConfirm()}
			title={`Force Unlock Shipment?`}
			type={"confirmation"}
			width={320}
		>
			<div>
				Another user may be editing this shipment.
				<br />
				Force unlocking will temporarily pause their editing session and allow
				you to make edits.
			</div>
		</TraxModal>
	);
};
